<template>
  <slot name="before"  />


  <div class="app-container"
       :class="[containerClass]"
  >
    <RouterView />

    <slot />
  </div>
  <slot name="after" />
</template>
<script setup>
import {useStore} from "vuex";
import {useRoute} from "vue-router";

const store = useStore();
const route = useRoute();

const props = defineProps({
  containerClass: [Array, String, Object],
});
</script>
<style lang="scss">
@import "@/css/functions";
@import "@/css/variables";

.test-notification-btn {
  position: fixed;
  top: 5px;
  right: 5px;
  z-index: 99999;
  width: 50px;
  aspect-ratio: 1/1;
  display: flex;
  background-color: themeColor('base');
  box-shadow: 0 toRem(15) toRem(35) 0 rgba(60, 66, 87, 0.20),
  0 toRem(5) toRem(15) 0 rgba(0, 0, 0, 0.08);
  border-radius: $border-radius-xl;
  justify-content: center;
  align-items: center;
  color: themeColor('primary');
}

#app {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.app-container {
  width: 100%;
  height: 100%;
  position: relative;

  &--guest {
    overflow-y: auto;
  }

  &--admin {
    display: flex;
    flex-direction: column;

    .page {
      bottom: $footer-height;
      top: 0;
      height: auto !important;
    }
  }
}

.app-container.full-screen {
  .sidebar {
    transform: translateX(-100%);
  }

  .floating-panel {
    opacity: 0;
    &__container {
      pointer-events: none;
    }
  }

  .object-widgets,
  .history-dashboard {
    transform: translateY(100%);
    bottom: 0;
  }

  .map .map__controls {
    .map__controls-group--tools {
      display: none;
    }

    .map__controls-group--main .control:not(.show_traffic){
      height: 0;
      border: none;
      opacity: 0;
    }

    .map__controls-group--main .control.show_traffic .control__container {
      border-radius: $border-radius-lg;
    }
  }
}
</style>